<template>
  <div class="year-select">
    <v-select
      class="year-select__select"
      :clearable="true"
      :model-value="modelValue"
      :options="years"
      :placeholder="placeholder"
      :searchable="true"
      @update:model-value="onSelect"
    />
  </div>
</template>

<script>
  import vSelect from "vue-select";

  const MIN_YEAR = 1900;

  export default {
    components: {
      vSelect,
    },

    computed: {
      placeholder() {
        return lavendlaObituary.createComment.yearPlaceholder;
      },

      years() {
        const currentYear = new Date().getFullYear();
        const years = [];

        for (let year = currentYear; year >= MIN_YEAR; year -= 1) {
          years.push(year);
        }

        return years;
      },
    },

    emits: ["update:modelValue"],

    methods: {
      onSelect(value) {
        this.$emit("update:modelValue", value ?? null);
      },
    },
    name: "YearSelect",

    props: {
      modelValue: {
        default: null,
        type: Number,
      },
    },
  };
</script>
